module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/syllabus/syllabus.component.css
// module id = ./src/app/syllabus/syllabus.component.css
// module chunks = main